import React from "react";
import { map } from "lodash";
import { Locale } from "@linkfluence/models/locale";
import intersperse from "@ui-kit/utils/intersperse";
import ClauseLabelsDisplay from "@radarly/components/clause/labels/labels";
import { ClauseLabels } from "@radarly/models/clause/label";

interface InlineRecapProps {
  clausesLabels: ClauseLabels[];
  locale: Locale;
  colorized?: boolean;
  maxItemPerLine?: number;
  className?: string;
}

export default function InlineRecap({
  clausesLabels,
  locale,
  colorized,
  maxItemPerLine = 25,
  className,
}: InlineRecapProps) {
  return (
    <span className={className}>
      {intersperse(
        map(clausesLabels, (clauseLabels, i) => (
          <span>
            {clauseLabels.labels.length > 1 && <span>&#x28;</span>}
            <ClauseLabelsDisplay
              colorized={colorized}
              clauseLabels={clauseLabels}
              locale={locale}
              max={maxItemPerLine}
            />
            {clauseLabels.labels.length > 1 && <span>&#x29;</span>}
          </span>
        )),
        (i) => (
          <span>, </span>
        )
      )}
    </span>
  );
}
